const RATE_SIGN = "~";

type Props = {
  baseAssetCode: string;
  quoteAssetCode: string;
  rate: string;
};

export const getRateSign = (): string => {
  return RATE_SIGN;
};

export const buildRateText = ({
  baseAssetCode,
  quoteAssetCode,
  rate,
}: Props): string => {
  return `1 ${baseAssetCode} ${getRateSign()} ${rate} ${quoteAssetCode}`;
};
